module.exports = __webpack_public_path__ + "static/tabs-257cc62ac56ec9a6863a6315b9b522c9.png";